import { Box, Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import type { User } from '@opendoor/auth-fe/context';
import { getInitials } from 'components/landing-pages-v2/utils/getInitials';

export function AccountIdentity({ user, mobile = false }: { user: User; mobile?: boolean }) {
  const name = user.fullName.trim() || user.firstName.trim();
  const email = user.email.trim();
  const initials = getInitials(name, user.firstName).join('');

  return (
    <Row
      className={cn(
        'items-center',
        mobile ? 'gap-3 border-b border-neutral-200 pb-3' : 'gap-2.5 px-2 py-3',
      )}
    >
      <Box
        aria-hidden
        className="inline-flex size-8 shrink-0 items-center justify-center rounded-full border border-transparent text-[#3c3733] [background:linear-gradient(90deg,#eae8e0,#d7d4cd)_border-box_padding-box,linear-gradient(27.77deg,rgb(249_248_245/60%)_8.46%,transparent_26.47%)_border-box,linear-gradient(-172.67deg,rgb(249_248_245/70%)_17.64%,transparent_43.76%)_border-box,linear-gradient(#bdbab3,#bdbab3)_border-box]"
      >
        <Text as="span" className="text-label-xs text-inherit">
          {initials}
        </Text>
      </Box>
      <Col className="min-w-0">
        {name && (
          <Row className="min-w-0 items-center gap-2">
            <Text
              as="span"
              className={cn(
                'truncate font-medium text-od-content-primary',
                mobile ? 'text-base leading-[22px]' : 'text-label-sm',
              )}
            >
              {name}
            </Text>
            {user.isAgent && (
              <Text
                as="span"
                className="inline-flex min-h-4.5 shrink-0 items-center rounded-full bg-blue-100 px-1.5 py-0.5 text-[11px] leading-3.5 font-medium text-blue-800"
              >
                Agent
              </Text>
            )}
          </Row>
        )}
        {email && (
          <Text
            as="span"
            className="truncate text-[13px] leading-5 font-normal text-od-content-secondary"
          >
            {email}
          </Text>
        )}
      </Col>
    </Row>
  );
}
